import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { Capacitor } from '@capacitor/core';
import { useAuthStore } from './store/authStore.js';
import { useSessionStore } from './store/sessionStore.js';

// En la app instalada (APK / iOS) la app viene dentro del binario: el service
// worker del POS web no sirve de nada y estorba. Guardaba en caché respuestas de
// la API (mesas y cuentas viejas sin red) y podía seguir sirviendo el código
// anterior después de instalar un APK nuevo. Se quita el que hubiera quedado de
// versiones pasadas, con sus cachés; en la app ya no se registra (App.jsx).
if (Capacitor.isNativePlatform() && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((rs) => rs.forEach((r) => r.unregister()))
    .catch(() => {});
  if (window.caches) caches.keys().then((ks) => ks.forEach((k) => caches.delete(k))).catch(() => {});
}

// Capture beforeinstallprompt BEFORE React mounts — the event can fire
// very early and a component-level listener would miss it.
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__installPrompt = e;
  window.dispatchEvent(new Event('installpromptready'));
});

if (import.meta.env.DEV) {
  window.__authStore = useAuthStore;
  window.__sessionStore = useSessionStore;
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
